import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Globe = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C9.79086 21 8 16.9706 8 12C8 7.02944 9.79086 3 12 3M12 21C14.2091 21 16 16.9706 16 12C16 7.02944 14.2091 3 12 3M3 12C3 7.02944 7.02944 3 12 3'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
      />
    ) : (
      <>
        <path
          d='M2.25 11.2512H7.12262C7.19862 8.71071 7.65888 6.39651 8.38693 4.64714C8.78584 3.68864 9.27962 2.8648 9.86532 2.26955C9.87176 2.26301 9.87821 2.25649 9.88468 2.25C5.73319 3.18506 2.57212 6.81468 2.25 11.2512Z'
          fill='currentColor'
        />
        <path
          d='M2.25 12.7488C2.57212 17.1853 5.73318 20.8149 9.88467 21.75C9.87821 21.7435 9.87176 21.737 9.86532 21.7305C9.27962 21.1352 8.78584 20.3114 8.38693 19.3529C7.65888 17.6035 7.19862 15.2893 7.12262 12.7488H2.25Z'
          fill='currentColor'
        />
        <path
          d='M14.1153 21.75C18.2668 20.8149 21.4279 17.1853 21.75 12.7488H16.8774C16.8014 15.2893 16.3411 17.6035 15.6131 19.3529C15.2142 20.3114 14.7204 21.1352 14.1347 21.7305C14.1282 21.737 14.1218 21.7435 14.1153 21.75Z'
          fill='currentColor'
        />
        <path
          d='M21.75 11.2512C21.4279 6.81468 18.2668 3.18506 14.1153 2.25C14.1218 2.25649 14.1282 2.26301 14.1347 2.26955C14.7204 2.8648 15.2142 3.68864 15.6131 4.64714C16.3411 6.39651 16.8014 8.71071 16.8774 11.2512H21.75Z'
          fill='currentColor'
        />
        <path
          d='M13.1002 3.33108C12.6946 2.9189 12.3236 2.76452 12 2.76452C11.6765 2.76452 11.3054 2.9189 10.8998 3.33108C10.4913 3.74629 10.0897 4.38462 9.73665 5.23293C9.09807 6.76732 8.66563 8.87477 8.5899 11.2512H15.4101C15.3344 8.87477 14.9019 6.76732 14.2634 5.23293C13.9103 4.38462 13.5087 3.74629 13.1002 3.33108Z'
          fill='currentColor'
        />
        <path
          d='M14.2634 18.7671C14.9019 17.2327 15.3344 15.1252 15.4101 12.7488L8.5899 12.7488C8.66563 15.1252 9.09807 17.2327 9.73665 18.7671C10.0897 19.6154 10.4913 20.2537 10.8998 20.6689C11.3054 21.0811 11.6765 21.2355 12 21.2355C12.3236 21.2355 12.6946 21.0811 13.1002 20.6689C13.5087 20.2537 13.9103 19.6154 14.2634 18.7671Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
